import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import { PageErrorBoundary, Toaster } from '@vivicta/ui';
import { trackInputModality } from './inputModality';
import { reportUnhandledErrors } from './unhandledErrors';
import '@backstage/ui/css/styles.css';
import './portal.css';
import './tailwind.generated.css';

trackInputModality();
reportUnhandledErrors();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    {/* Last resort: each page has its own boundary; this one catches the shell. */}
    <PageErrorBoundary title="The portal">{App.createRoot()}</PageErrorBoundary>
    <Toaster />
  </>,
);
